import { render, staticRenderFns } from "./InspectionTimesInRentalAnomaly.vue?vue&type=template&id=22b0474f&scoped=true&"
import script from "./InspectionTimesInRentalAnomaly.vue?vue&type=script&lang=ts&"
export * from "./InspectionTimesInRentalAnomaly.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b0474f",
  null
  
)

export default component.exports